import { AxiosInstance, AxiosResponse } from 'axios';
import { AdhesionApiFactory, Fichier, FormulaireDePaiement, Renouvellement } from './swagger';

export interface IApi {
  getBulletinAdhesion(params): Promise<Fichier>;
  signerAdhesion(param): Promise<void>;
  getRenouvellement(param): Promise<Renouvellement>;
  postPaiementEnLigne(numeroAdhesion): Promise<FormulaireDePaiement>;
  putMandatByNumeroAdhesion(params): Promise<number>;
  postDemanderResiliationAdhesion(params): Promise<number>;
}

const create = (endpoint: string, axiosClient: AxiosInstance) => {
  const AdhesionApi = AdhesionApiFactory({}, endpoint, axiosClient);

  const getBulletinAdhesion = (numero): Promise<Fichier> =>
    new Promise((resolve, reject) => {
      AdhesionApi.getAdhesionBulletinAdhesionByNumeroAdhesion(numero)
        .then((response: AxiosResponse<Fichier>) => {
          resolve(response.data);
        })
        .catch((error: any) => reject(error));
    });

  const signerAdhesion = (param): Promise<any> =>
    new Promise((resolve, reject) => {
      AdhesionApi.postSignerAdhesionById(param.numeroAdhesion, {
        tokenSaga: param.token,
      })
        .then((response: AxiosResponse<void>) => {
          resolve(response);
        })
        .catch((error: any) => reject(error));
    });

  const getRenouvellement = (param): Promise<Renouvellement> =>
    new Promise((resolve, reject) => {
      AdhesionApi.getRenouvellementByNumeroAdhesion(param.numeroAdhesion)
        .then((response: AxiosResponse<Renouvellement>) => {
          resolve(response.data);
        })
        .catch((error: any) => reject(error));
    });

  const postPaiementEnLigne = (numeroAdhesion): Promise<FormulaireDePaiement> =>
    new Promise((resolve, reject) => {
      AdhesionApi.postPaiementEnLigne({ numeroAdhesion: numeroAdhesion })
        .then((response: AxiosResponse<FormulaireDePaiement>) => {
          resolve(response.data);
        })
        .catch((error: any) => reject(error));
    });

  const putMandatByNumeroAdhesion = (params): Promise<number> =>
    new Promise((resolve, reject) => {
      AdhesionApi.putMandatByNumeroAdhesion(params.numeroAdhesion, {
        bic: params.bic,
        iban: params.iban,
      })
        .then((response: AxiosResponse<void>) => {
          resolve(response.status);
        })
        .catch((error: any) => reject(error));
    });

  const postDemanderResiliationAdhesion = (params): Promise<number> =>
    new Promise((resolve, reject) => {
      AdhesionApi.postDemanderResiliationAdhesion(params.numeroAdhesion, {
        raison: params.raisonResiliation,
      })
        .then((response: AxiosResponse<void>) => {
          resolve(response.status);
        })
        .catch((error: any) => reject(error));
    });

  return {
    getBulletinAdhesion,
    signerAdhesion,
    postPaiementEnLigne,
    getRenouvellement,
    putMandatByNumeroAdhesion,
    postDemanderResiliationAdhesion,
  };
};

export default create;
